import React, { useEffect,useState,useContext } from "react";
import solicitudRepresentacionService from '../../../services/solicitudRepresentacionService'

import Spinner from '../../Spinner/Spinner'
//import Modal from '@material-ui/core/Modal';
import { Modal, Select, InputLabel, MenuItem } from '@material-ui/core';

import { DeleteRounded, Close } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import { red } from '@material-ui/core/colors';


import  AutosizeInput from 'react-input-autosize';

import DateFnsUtils from '@date-io/date-fns';
import esLocale from "date-fns/locale/es";
import { KeyboardDatePicker,MuiPickersUtilsProvider } from '@material-ui/pickers'

import { useAlert } from 'react-alert'
import { AppContext } from '../../../App'
import { useAuth } from "react-oidc-context"

let closeImg = {cursor:'pointer', float:'right', marginTop: '5px', width: '20px'};

function  SolicitudRepresentacion({tipoSolicitudRepresentacion}){

    const [isLoading, setIsLoading] = useState(false)
    const [isLoadingModal, setIsLoadingModal] = useState(false)
    //const [isLoaded, setIsLoaded] = useState(false)

    const [nifRepresentacionModal, setNifRepresentacionModal] = useState("");
    const [fechaVigenciaSolicitudModal, setFechaVigenciaSolicitudModal] = useState(new Date(new Date().setFullYear(new Date().getFullYear() + 5)));
    const [tipoRepresentacionSolicitudComboModal, setTipoRepresentacionSolicitudComboModal] = useState("0");

    const [resultadoServicioSolicitud, setResultadoServicioSolicitud] = useState("");
    const [resultadoCorrectoServicioSolicitud, setResultadoCorrectoServicioSolicitud] = useState("");

    //MODAL    
    const [open, setOpen] = useState(false);    
    const [modalStyle] = useState(getModalStyle);
    const [modalStyleRedText] = useState(getModalStyleRedText);
    //const classes = useStyles();
    // *********

    //ALERT
    const alertInfo = useAlert()
    // *********

    const {state, dispatch} = useContext(AppContext)
    const idcorl=state.idCorrelacion
    const auth = useAuth();
    const token = auth.user?.access_token;

    function nombreBotonSolicitud()
    {
        if (tipoSolicitudRepresentacion=='1') 
            return 'Solicitar representar a un usuario';
        else if (tipoSolicitudRepresentacion=='2')
            return 'Nombrar representante';
        else
            return 'TIPO DE SOLICITUD NO ENCONTRADA. REVISAR ERROR.';
    }

    function textoCabeceraModalSolicitud()
    {
        if (tipoSolicitudRepresentacion=='1') 
            return 'Solicitar representar a un usuario';
        else if (tipoSolicitudRepresentacion=='2')
            return 'Nombrar representante';
        else
            return 'TIPO DE SOLICITUD NO ENCONTRADA. REVISAR ERROR.';
    }

    function textoNIFModalSolicitud()
    {
        if (tipoSolicitudRepresentacion=='1') 
            return 'NIF del representado';
        else if (tipoSolicitudRepresentacion=='2')
            return 'NIF del representante';
        else
            return 'TIPO DE SOLICITUD NO ENCONTRADA. REVISAR ERROR.';
    }


    //MODAL *********************************** 
    function resetModalInputs(){
        setNifRepresentacionModal("");
        setFechaVigenciaSolicitudModal(new Date(new Date().setFullYear(new Date().getFullYear() + 5)));
        setTipoRepresentacionSolicitudComboModal("0");
    }

    const handleClose = () => {
        resetModalInputs();
        setOpen(false);
    };

    /*const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") 
            return;        
        setOpen(false);
    };*/

    const handleOpen = () => {        
        resetModalInputs();
        setOpen(true);
    };

    function getModalStyle() {
        const top = 50;
        const left = 50;
      
        return {
          //top: `${top}%`,
          //left: `${left}%`,
          //transform: `translate(-${top}%, -${left}%)`,

          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',

          position: 'absolute',
          width: 500,          
          border: '2px solid #000',
          boxShadow: 5,        
          backgroundColor: '#d5f4e6',
          padding : '2px 4px 3px',
        };
    }

    function getModalStyleRedText() {        
        return {
          color: 'red',          
        };
    }

   
    /*
    const useStyles = makeStyles((theme) => ({
        paper: {
          position: 'absolute',
          width: 400,
          backgroundColor: theme.palette.background.paper,
          border: '2px solid #000',
          boxShadow: theme.shadows[5],
          padding: theme.spacing(2, 4, 3),
        },
    }));
    */

    const handleTipoRepresentacionChange = (event) => {
        setTipoRepresentacionSolicitudComboModal(event.target.value);
      };

    const formateaFechaGuiones = (fecha) => {
           
        var fechaFormateada = '';
        
        if (fecha != null && !isNaN(fecha.getTime()) && fecha instanceof Date){
            var fechaSinGMT = new Date(fecha.toUTCString().split(' ').slice(0, 4).join (' '))
            const dia = fechaSinGMT.getDate().toString().padStart(2,'0');
            const mes = (fechaSinGMT.getMonth() + 1).toString().padStart(2,'0');
            const anyo = fechaSinGMT.getFullYear().toString();
  
          fechaFormateada = dia + '-' + mes + '-' + anyo;
        }
         
        return fechaFormateada;
    }

    function handleValidation()
    {        
      let formIsValid = true;
      
      formIsValid = handleValidationNIF() && handleValidationFecha();        	
      
      return formIsValid;
    }


    function handleValidationFecha()
    {        
        let formIsValid = true;

        var fechaFormateada = formateaFechaGuiones(fechaVigenciaSolicitudModal);

        if(!fechaFormateada){
            alert("Inserte una fecha válida.");
            formIsValid = false;
        }     	
        else if( !(/^(?:(?:31(-)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(-)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(-)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(-)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/.test(fechaFormateada)) ){
            //if( !(/^[0-9]{2}-[0-9]{2}-[0-9]{4}$/.test(fechaVigenciaSolicitudModal)) ){
            alert("Formato de Fecha incorrecto."); 
            formIsValid = false;
        } 
        else if( fechaVigenciaSolicitudModal <= new Date()){
            alert("La fecha de vigencia no puede ser menor que la actual."); 
            formIsValid = false;
        }       	
        
        return formIsValid;
    }

    function handleValidationNIF()
    {        
      let formIsValid = true;

      if(!nifRepresentacionModal){
        alert("CAMPO NIF OBLIGATORIO"); 
        formIsValid = false;
      }      
      else if( !(/^[0-9]{8}[A-Za-z]{1}$/.test(nifRepresentacionModal) ||
           /^[A-Za-z]{1}[0-9]{7}[A-Za-z]{1}$/.test(nifRepresentacionModal) ||
           /^[A-Za-z]{1}[0-9]{8}$/.test(nifRepresentacionModal))
        ){
          alert("Formato de NIF/CIF incorrecto."); 
          formIsValid = false;
      }      	
      
      return formIsValid;
    }


    function mapeaSolicitudForm(){
        let datosSolicitudForm = {        
            "tipoRepresentacion" : parseInt(tipoRepresentacionSolicitudComboModal),//'-1', //
            //"fechaSolicitud": formateaFechaGuiones(new Date()),
            //"vigencia": formateaFechaGuiones(fechaVigenciaSolicitudModal),
            "vigencia": getDateIgnoreTimezone1(fechaVigenciaSolicitudModal),
            "tipoSolicitudRepresentacion": parseInt(tipoSolicitudRepresentacion),
            "nifDestinatarioSolicitud": nifRepresentacionModal.toUpperCase()            
        }

        return datosSolicitudForm;
    }

    function getDateIgnoreTimezone1(date){
        if(date && date.getUTCHours() !== 0){            
            return new Date(new Date(date.getTime()).setHours(23,59,59,0)- date.getTimezoneOffset() * 60000);
        }
        else{
            return date;
        }            
    }
        
/*
    const getDateIgnoreTimezone = (date) =>
        date && date.getUTCHours() !== 0
            ? ((theDate) =>
                new Date(theDate.getTime() - theDate.getTimezoneOffset() * 60 * 1000))(
                new Date(date)
            )
            : date;
*/

    function handleModalSolicitud()
    {           
        //e.preventDefault();        
        if(handleValidation()){             
            setIsLoadingModal(true)        
            solicitudRepresentacionService({datosSolicitudForm: mapeaSolicitudForm(), idcorl, token})
            .then(datos => {
                setResultadoCorrectoServicioSolicitud(datos.ok)
                setResultadoServicioSolicitud(datos)
                setIsLoadingModal(false)
                //setIsLoaded(true)
                
                if (datos.ok){
                    actualizaPendientes(datos.respuesta);
                    alertInfo.success("Solicitud enviada con éxito.");                       
                    handleClose();
                }
                else{
                    alertInfo.error(<div>Solicitud NO enviada. <br/><br/> {datos.mjeError} </div>, { timeout: 0 });  
                }
        
            }).catch((error) => {
                alert("Ha ocurrido un error. Por favor póngase en contacto con soporte (soportec@navarra.es) facilitando el identificador de correlación.");
                setIsLoadingModal(false)
                handleClose();
            })            
                                    
        }
    }

    function actualizaPendientes(solicitudNueva){
        const listPendientes = state.arraySolicitudesRepresentacionPendientes;    
        listPendientes.push(solicitudNueva);    
        dispatch({ type: 'UPDATE_SOLICITUDES_PENDIENTES_STATUS', data: listPendientes,});

        dispatch({ type: 'UPDATE_RESET_FILTRADO', data: true,});
    }

    // ******************************************


    const handleSubmit = (e) => {
        e.preventDefault();                       
        handleOpen()                  
    };

    
    return (
        <>
            {isLoading && <div><strong>Actualizando...</strong><Spinner></Spinner></div>}

            {!isLoading &&
                <form className='form' onSubmit={handleSubmit}>
                    <md-content className="col-sm-3 comboEditable _md" >
                        <div>                                        
                            <span> 
                                <button type="button" className="btn btn-success" onClick={handleSubmit}>{nombreBotonSolicitud()}</button>                                
                            </span>
                        </div>
                    </md-content>
                    
                </form>
            }
          
            <Modal open={open} onClose={handleClose} 
                disableBackdropClick={true} 
                aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
                <div style={modalStyle} >
                    <Close style={closeImg} onClick={handleClose}/>
                    <h2 id="simple-modal-title">{textoCabeceraModalSolicitud()}</h2> 
                   
                    {isLoadingModal && <div><strong>Solicitando...</strong><Spinner></Spinner></div>}
                   
                    {!isLoadingModal &&
                        <div>
                            <br/>
                            <label>{textoNIFModalSolicitud()}: &nbsp;</label>              
                                        <input onChange={(e) => setNifRepresentacionModal(e.target.value.trim())}
                                            value={nifRepresentacionModal.trim()} />
                                        &nbsp; &nbsp; &nbsp;
                            
                            <br/>
                            <br/>
                            <label >Vigencia de la representación (dd-mm-aaaa): &nbsp;</label>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                <KeyboardDatePicker
                                    clearable
                                    autoOk                                       
                                    style={{width:"25%"}}  
                                    InputAdornmentProps={{ position: "start" }}
                                    InputProps={{ style: { fontSize: 14 } }}
                                    //value={new Date(fechaSolicitante)}
                                    minDate={new Date()}
                                    disablePast
                                    minDateMessage = "Fechas anteriores a la actual no son válidas"
                                    value={fechaVigenciaSolicitudModal}
                                    onChange={date => setFechaVigenciaSolicitudModal(date)}
                                    /*
                                    onChange={date => {
                                        const theDate = getDateIgnoreTimezone(date);
                                        setFechaVigenciaSolicitudModal(theDate);}}
                                    */
                                    format="dd-MM-yyyy"
                                />
                            </MuiPickersUtilsProvider >                                            
                            
                            <br/>
                            <br/>
                            <label>Tipo de representación: &nbsp;</label>
                            <Select id="selectTipoRepresentacion" 
                                value={tipoRepresentacionSolicitudComboModal}
                                onChange={handleTipoRepresentacionChange}
                                >
                                <MenuItem value="0">Completa</MenuItem>                               
                            </Select>

                            <br/>
                            <br/>
                            <button type="button" className="btn btn-success" onClick={handleModalSolicitud}>Enviar solicitud</button>
                            <br /> 
                        </div>
                    }                                     
                </div>
            </Modal>
            

        </>
        )
}
export default SolicitudRepresentacion
